// extracted by mini-css-extract-plugin
export var fileExt = "_sa-8";
export var fileIcon = "_sa-6";
export var fileLink = "_sa-5";
export var fileName = "_sa-7";
export var image = "_sa-1";
export var imageError = "_sa-3";
export var imageErrorIcon = "_sa-4";
export var imageLink = "_sa-0";
export var imageLoaded = "_sa-2";